<template>
  <div
    class="product-badge"
    :style="{ 'background-color': backgroundColor }"
    :class="badgeClass"
  >
    <span
      class="product-badge__text"
      :class="textClass"
      v-text="text"
    />
  </div>
</template>

<script>

/**
 * Vue: Product badge (product-badge)
 * -----------------------------------------------------------------------------
 * Product category badge.
 *
 */
export default {
  name: 'ProductBadge',

  props: {
    backgroundColor: {
      type: String,
      default: '',
    },
    badgeClass: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textClass: {
      type: String,
      default: 'text-heading-s text-heading-m-desktop',
    },
  },
}
</script>

<style lang="scss">
@import './product-badge';
</style>
